import React from "react";
import CertificateArray from "../../helper/Certificates/certificates";
import style from "../../sass/certificate.module.scss";
export const Certificate = () => {
     return (
          <div className={style.certificate}>
               <div className={style.certificate_container}>
                    <div className={style.certificate_layout}>
                         {CertificateArray.map((item) => (
                              <div className={style.certificate_layout_items}>
                                   <img src={item.Path} key={item.Id} width={"100%"} height={"90%"} />
                                   <a href={item.Link} target="_blank" rel="noopener noreferrer">
                                        <h2>{item.Name}</h2>
                                   </a>
                              </div>
                         ))}
                    </div>
               </div>
          </div>
     );
};

export default Certificate;
